module.exports = __webpack_public_path__ + "Flama-Basic.ttf?cc636a5afe6d03971a3c6a0173074c70";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Basic.ttf
// module id = 895
// module chunks = 0